import { connect } from '@lumapps/redux/react';

import { mapLoadingStateToProps } from '../../../utils/mapLoadingStateToProps';
import { BlockList } from './BlockList';

export const ConnectedBlockList = connect(mapLoadingStateToProps, null)(BlockList);
export { ConnectedBlockList as BlockList };
